import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Wordmark } from '@/components/brand/wordmark';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * GLOBAL HATA SINIRI
 *
 * Bir bileşen render sırasında patlarsa React tüm ağacı söker ve kullanıcı
 * BEYAZ EKRAN görür. Beyaz ekran kullanıcıya "site bozuk" der ve yapacak
 * bir şey bırakmaz.
 *
 * Bunun yerine: marka diliyle bir hata ekranı ve iki güvenli çıkış —
 * yeniden dene, ana sayfa.
 *
 * Stack trace kullanıcıya GÖSTERİLMEZ. Geliştirmede konsola yazılır;
 * üretimde de konsola yazılır ama ekranda yalnızca insanca bir mesaj olur.
 */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Üretimde de konsola yazılır: tarayıcı hata raporlayıcısı varsa
    // yakalayabilsin. Ekrana hiçbir teknik ayrıntı çıkmaz.
    console.error('Beklenmeyen arayüz hatası:', error, info.componentStack);
  }

  private handleRetry = (): void => {
    // Ağaç yeniden kurulur; geçici bir hata ise sayfa toparlanır.
    this.setState({ hasError: false });
  };

  render(): ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="flex min-h-dvh items-center justify-center bg-paper px-4 py-16">
        <div className="w-full max-w-md text-center">
          <Wordmark size="md" className="mx-auto" />

          <h1 className="mt-6 font-serif text-xl text-ink">
            Bir şeyler ters gitti
          </h1>

          <p className="mt-2 text-sm text-ink-subtle">
            Beklenmeyen bir sorun oluştu. Sayfayı yeniden deneyebilir veya ana
            sayfaya dönebilirsiniz. Sorun sürerse bizimle iletişime geçin.
          </p>

          <div className="mt-6 flex flex-wrap justify-center gap-2">
            <button
              type="button"
              onClick={this.handleRetry}
              className="rounded-sm bg-leaf-900 px-4 py-2.5 text-sm text-paper transition-colors duration-fast hover:bg-leaf-800"
            >
              Yeniden dene
            </button>

            {/*
              Router bozulmuş olabilir; bu yüzden <Link> değil tam sayfa
              gezinme kullanılır. Uygulama sıfırdan kurulur.
            */}
            <a
              href="/"
              className="rounded-sm border border-line px-4 py-2.5 text-sm text-ink transition-colors duration-fast hover:border-ink-subtle"
            >
              Ana sayfa
            </a>
          </div>

          <p className="mt-6">
            <a
              href="/iletisim"
              className="text-xs text-ink-subtle underline-offset-2 hover:underline"
            >
              İletişim bilgilerimiz
            </a>
          </p>
        </div>
      </div>
    );
  }
}
